import React from 'react';
import { ExtensionesTelefonicasComponent } from '../components/ExtensionesTelefonicas/ExtensionesTelefonicasComponent';
import Layout from '../components/Layout';

export default function ExtensionesTelefonicas() {
  return (
    <div>
      <Layout />
      <div>
        <ExtensionesTelefonicasComponent />
      </div>
    </div>
  );
}
